import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { SubmitStatus } from '../../../../models/form.model';
import { ProfileService } from '../../../profile/services/profile.service';
import { WindowRefService } from '../../../../services/window-ref.service';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { AuthEventType } from '../../../../enums/event/event.enum';
import { FormTracking } from '../../../../config/eev-form-tracking.config';
import { FormSubmit } from '../../../../models/event-data.model';
import { AuthFormName } from '../../../../enums/event/event-data.enum';
import { ToastService } from '../../../shared/services/toast.service';

interface ModalData {
  email: string;
  cid: string;
  customerId: number;
}

interface EmailForm {
  email: FormControl<string>;
}

@Component({
    selector: 'app-update-email-modal',
    templateUrl: './update-email-modal.component.html',
    styleUrls: ['./update-email-modal.component.scss'],
    standalone: false
})
export class UpdateEmailModalComponent {
  emailForm: FormGroup<EmailForm> = new FormGroup({
    email: new FormControl(this.data.email, [Validators.required, Validators.email]),
  });
  formSubmitStatus: SubmitStatus;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    public dialogRef: MatDialogRef<UpdateEmailModalComponent>,
    private readonly profileService: ProfileService,
    private readonly windowRefService: WindowRefService,
    private readonly toastService: ToastService,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  updateEmail() {
    this.eventTrackingService.trackEvent<FormSubmit>(
      AuthEventType.FORM_SUBMIT,
      FormTracking[AuthFormName.UPDATE_EMAIL_ADDRESS].formSubmitEvent
    );
    this.emailForm.markAllAsTouched();
    if (this.emailForm.invalid) {
      return;
    }
    this.formSubmitStatus = 'pending';
    this.profileService
      .updateProfileEmail({
        customerId: this.data.customerId,
        reqBody: {
          email: this.emailForm.controls.email.value,
          add: false,
          update: true,
        },
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.formSubmitStatus = 'success';
          this.toastService.addToast({ notificationType: 'primary-dark', text: 'Email address updated.' });
          const FS_EVENT = '[Auth] Loan Email Update Success';
          this.windowRefService.nativeWindow.FS.event(FS_EVENT);
          this.dialogRef.close();
        },
        error: () => (this.formSubmitStatus = 'error'),
      });
  }
}
